import type { BadgeProps } from '@hover/blueprint';
import { Badge, transition } from '@hover/blueprint';
import React from 'react';

import { withHover } from '../../helpers/styles';

export interface CarouselBadgeProps extends BadgeProps {
  label?: string;
}

export const getCarouselThumbnailStyles = (alwaysShow?: boolean) => ({
  opacity: alwaysShow ? 1 : 0,
  ...withHover({ _groupHover: { opacity: 1 } }),
  _groupFocusWithin: { opacity: 1 },
  ...transition.easing250('background', 'opacity'),
});

export const CarouselBadge = ({ label = '', ...props }: CarouselBadgeProps) => (
  <Badge
    colorMode="dark"
    data-testid="generated-image-style"
    variant="glass"
    {...props}
    sx={{ ...props.sx, opacity: 1 }}
  >
    {label}
  </Badge>
);
